"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _luxon = require("luxon");

var _icons = require("@sunrun/component-library/icons");

var _componentLibrary = require("@sunrun/component-library");

var _colors = require("./colors");

var ChartRanges = _interopRequireWildcard(require("../../constants/chartRanges"));

var _DownloadCsv = _interopRequireDefault(require("../DownloadCsv"));

var _formatCSVExport = require("../../helpers/formatCSVExport");

var _date = require("../../helpers/date");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Text = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));

var DownloadIcon = (0, _styled["default"])(_icons.Download)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  top: 2px;\n  margin-left: 10px;\n"])));

var ModalBodyContainer = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 50px;\n"])));

var DatePickerContainer = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  > div {\n    width: 45%;\n  }\n"])));

var DownloadText = _styled["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  div {\n    // spinner when loading data\n    height: 18px;\n    transform: scale(0.4);\n  }\n"])));

var Option = _styled["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  text-align: left;\n  div {\n    flex: 1;\n    color: ", ";\n  }\n  span {\n    justify-content: right;\n    color: ", ";\n  }\n"])), function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? _colors.GRAYED_OUT_COLOR : 'inherit';
}, _colors.GRAYED_OUT_COLOR);

var FormattedOptionLabel = function FormattedOptionLabel(_ref2) {
  var label = _ref2.label,
      isDisabled = _ref2.isDisabled;
  return /*#__PURE__*/_react["default"].createElement(Option, {
    isDisabled: isDisabled
  }, /*#__PURE__*/_react["default"].createElement("div", null, label), isDisabled && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("em", null, "Not yet available")));
};

FormattedOptionLabel.propTypes = {
  label: _propTypes["default"].string.isRequired,
  isDisabled: _propTypes["default"].bool
};
FormattedOptionLabel.defaultProps = {
  isDisabled: false
};

var ExportDataLink = function ExportDataLink(_ref3) {
  var computeNewRange = _ref3.computeNewRange,
      currentRange = _ref3.currentRange,
      disabledDateRanges = _ref3.disabledDateRanges,
      endDate = _ref3.endDate,
      error = _ref3.error,
      loading = _ref3.loading,
      onDownloadClick = _ref3.onDownloadClick,
      productionData = _ref3.productionData,
      ptoDateISO = _ref3.ptoDateISO,
      rootId = _ref3.rootId,
      startDate = _ref3.startDate,
      zone = _ref3.zone,
      today = _ref3.today;

  var todayDateTime = _luxon.DateTime.fromISO(today, {
    zone: zone
  });

  var startDateTime = _luxon.DateTime.fromISO(startDate, {
    zone: zone
  });

  var endDateTime = _luxon.DateTime.fromISO(endDate, {
    zone: zone
  });

  var ptoDateTime = _luxon.DateTime.fromISO(ptoDateISO, {
    zone: zone
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      rangeSelection = _useState4[0],
      setRangeSelection = _useState4[1];

  var _useState5 = (0, _react.useState)(startDateTime),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedStartDate = _useState6[0],
      setSelectedStartDate = _useState6[1];

  var _useState7 = (0, _react.useState)(endDateTime),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedEndDate = _useState8[0],
      setSelectedEndDate = _useState8[1];

  var fields = ['Date', 'Solar Produced (kWh)', 'End-of-Day Meter Reading (kWh)'];
  (0, _react.useEffect)(function () {
    if (currentRange) {
      setRangeSelection(ChartRanges[currentRange.replace(/\s/g, '')]); // removes space for ALL TIME
    }
  }, [currentRange]);
  (0, _react.useEffect)(function () {
    // pre-populate selected dates from ones user selected in portal
    if (currentRange === ChartRanges.CUSTOM) {
      setSelectedStartDate(_luxon.DateTime.fromISO(startDate, {
        zone: zone
      }));
      setSelectedEndDate(_luxon.DateTime.fromISO(endDate, {
        zone: zone
      }));
    }
  }, [endDate, startDate]);
  var rangeOptions = [{
    value: ChartRanges.YESTERDAY,
    label: 'Yesterday',
    isDisabled: disabledDateRanges.includes(ChartRanges.YESTERDAY)
  }, {
    value: ChartRanges.LAST_7_DAYS,
    label: 'Last 7 Days',
    isDisabled: disabledDateRanges.includes(ChartRanges.LAST_7_DAYS)
  }, {
    value: ChartRanges.LAST_30_DAYS,
    label: 'Last 30 Days',
    isDisabled: disabledDateRanges.includes(ChartRanges.LAST_30_DAYS)
  }, {
    value: ChartRanges.LAST_12_MONTHS,
    label: 'Last 12 Months'
  }, {
    value: ChartRanges.ALLTIME,
    label: 'All Time'
  }, {
    value: ChartRanges.CUSTOM,
    label: 'Choose a range...'
  }];

  var getProductionCoordinates = function getProductionCoordinates(data) {
    switch (rangeSelection) {
      case ChartRanges.ALLTIME:
        return (0, _formatCSVExport.getMonthlyCoordinates)(data, ptoDateTime, todayDateTime, zone);

      case ChartRanges.CUSTOM:
        return (0, _formatCSVExport.getMonthlyCoordinates)(data, selectedStartDate, selectedEndDate, zone);

      default:
        return (0, _formatCSVExport.getMonthlyCoordinates)(data, startDateTime, endDateTime, zone);
    }
  };

  var getDisplayDates = function getDisplayDates(date1, date2) {
    if ((0, _date.isSameDay)(date1, date2, zone)) {
      return (0, _date.mysunrunDateFormat)(date1);
    }

    if ((0, _date.isSameYear)(date1, date2, zone)) {
      return "".concat((0, _date.mysunrunDateFormat)(date1, zone, false), " - ").concat((0, _date.mysunrunDateFormat)(date2, zone));
    }

    return "".concat((0, _date.mysunrunDateFormat)(date1, zone), " - ").concat((0, _date.mysunrunDateFormat)(date2, zone));
  };

  var getFileName = function getFileName() {
    var fileNameStartDate;
    var fileNameEndDate;

    switch (rangeSelection) {
      case ChartRanges.ALLTIME:
        fileNameStartDate = ptoDateTime;
        fileNameEndDate = todayDateTime;
        break;

      case ChartRanges.CUSTOM:
        fileNameStartDate = selectedStartDate;
        fileNameEndDate = selectedEndDate;
        break;

      default:
        fileNameStartDate = startDateTime;
        fileNameEndDate = endDateTime;
        break;
    }

    return "Daily Solar Production for ".concat(getDisplayDates(fileNameStartDate, fileNameEndDate));
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_componentLibrary.Modal.Modal, {
    isOpen: modalOpen,
    onClose: function onClose() {
      return setModalOpen(false);
    },
    rootId: rootId,
    ariaHideApp: !!rootId
  }, /*#__PURE__*/_react["default"].createElement(_componentLibrary.Modal.Heading, null, "Confirm data selection"), /*#__PURE__*/_react["default"].createElement(_componentLibrary.Modal.Body, null, /*#__PURE__*/_react["default"].createElement(ModalBodyContainer, null, /*#__PURE__*/_react["default"].createElement("p", null, "Export range of solar production history (.csv)."), /*#__PURE__*/_react["default"].createElement(_componentLibrary.SelectDropdown, {
    menuHeight: "175px",
    value: rangeOptions.find(function (a) {
      return a.value === rangeSelection;
    }),
    onChange: function onChange(e) {
      computeNewRange(e.value);
      setRangeSelection(e.value);
    },
    options: rangeOptions,
    formatOptionLabel: FormattedOptionLabel
  }), rangeSelection === ChartRanges.CUSTOM && /*#__PURE__*/_react["default"].createElement(DatePickerContainer, null, /*#__PURE__*/_react["default"].createElement(_componentLibrary.DatePicker, {
    value: new Date(selectedStartDate),
    onChange: function onChange(e) {
      return setSelectedStartDate(e);
    },
    disableFuture: true,
    format: "D",
    minDate: ptoDateISO,
    helperText: "Start date"
  }), /*#__PURE__*/_react["default"].createElement(_componentLibrary.DatePicker, {
    value: new Date(selectedEndDate),
    onChange: function onChange(e) {
      return setSelectedEndDate(e);
    },
    disableFuture: true,
    minDate: ptoDateISO,
    format: "D",
    helperText: "End date"
  })))), /*#__PURE__*/_react["default"].createElement(_componentLibrary.Modal.Buttons, null, /*#__PURE__*/_react["default"].createElement(_DownloadCsv["default"], {
    styles: "primary",
    fileName: getFileName(),
    fields: fields,
    onDownloadClick: onDownloadClick,
    data: productionData && (0, _formatCSVExport.formatSiteProductionData)(fields, getProductionCoordinates(productionData)),
    disabled: rangeSelection === ChartRanges.CUSTOM && selectedStartDate > selectedEndDate || loading || !!error
  }, /*#__PURE__*/_react["default"].createElement(DownloadText, null, error, loading && !error && /*#__PURE__*/_react["default"].createElement(_componentLibrary.Spinner, {
    spinnerColor: _colors.WHITE
  }), !error && !loading && 'Export')), /*#__PURE__*/_react["default"].createElement(_componentLibrary.Button, {
    secondary: true,
    onClick: function onClick() {
      return setModalOpen(false);
    }
  }, "Cancel"))), /*#__PURE__*/_react["default"].createElement(Text, {
    onClick: function onClick() {
      return setModalOpen(true);
    }
  }, "Energy Produced for ".concat(getDisplayDates(startDateTime, endDateTime)), /*#__PURE__*/_react["default"].createElement(DownloadIcon, {
    color: _colors.BRAND_GREEN
  })));
};

ExportDataLink.propTypes = {
  computeNewRange: _propTypes["default"].func.isRequired,
  currentRange: _propTypes["default"].string.isRequired,
  disabledDateRanges: _propTypes["default"].arrayOf(_propTypes["default"].string),
  endDate: _propTypes["default"].string.isRequired,
  error: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  onDownloadClick: _propTypes["default"].func,
  productionData: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  ptoDateISO: _propTypes["default"].string.isRequired,
  rootId: _propTypes["default"].string,
  startDate: _propTypes["default"].string.isRequired,
  today: _propTypes["default"].string.isRequired,
  zone: _propTypes["default"].string.isRequired
};
ExportDataLink.defaultProps = {
  disabledDateRanges: [],
  error: null,
  loading: false,
  onDownloadClick: null,
  productionData: null,
  rootId: null
};
var _default = ExportDataLink;
exports["default"] = _default;